import React from 'react';

// This context is meant to contain all Event data type values.
const EventsContext = React.createContext<App.Event[] | null>(null);

export default EventsContext;
